<template>
  <div class="o-wrapper">
    <div class="o-layout o-layout--center u-mb-20">
      <div class="o-item  u-6/12@desktop">
        <div
          class="o-layout o-layout--matchheight o-layout--center o-layout--stacked"
        >
          <div
            class="o-item  u-4/12@tablet"
            v-for="(tab, index) in tabs"
            :key="tab.title"
          >
            <a
              href="#"
              class="card c-card-result"
              :class="{ 'is-active': index == selectedIndex }"
              @click.prevent="selectTab(index)"
            >
              <vnodes :vnodes="tab.$slots.button" v-if="tab.$slots.button" />
              <h3 class="u-h5" v-else>{{ tab.title }}</h3>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="o-layout o-layout--center">
      <div class="o-item  u-8/12@desktop">
        <div class="content">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vnodes from './helpers/Vnodes.vue';
export default {
  data() {
    return {
      selectedIndex: null,
      tabs: [],
    };
  },
  mounted() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab(i) {
      this.selectedIndex = i;

      // loop over all the tabs
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i;
      });
    },
  },
  components: {
    Vnodes,
  },
};
</script>
